export default {"src":"/_next/static/media/round-3.635269c9.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};